const _ = {
  CAMPAIGN_ID: "campaignId",
  INVITE_CODE: "inviteCode",
  LANGUAGE: "lang",
  OWNER_ADDRESS: "ownerAddresses",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_CONTENT: "utm_content",
  UTM_ID: "utm_id",
  UTM_MEDIUM: "utm_medium",
  UTM_SOURCE: "utm_source",
  UTM_TERM: "utm_term"
}, E = [_.INVITE_CODE];
export {
  _ as QUERY,
  E as QUERY_FILTER_WHITELIST
};
//# sourceMappingURL=query.js.map
